import * as React from 'react';

import {
  Datagrid,
  DateField,
  ImageField,
  List,
  SearchInput,
  TextField,
  useTranslate,
} from 'react-admin';
import { Theme, useMediaQuery } from '@mui/material';

import MobileGrid from './MobileGrid';

const filters = [<SearchInput source="q" alwaysOn />];

const NotificationsList = () => {
  const isXsmall = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm')
  );
  const isSmall = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'));
  const translate = useTranslate();

  return (
    <List
      filters={!isSmall ? filters : undefined}
      bulkActionButtons={false}
      title={translate('pos.menu.notifications')}
    >
      {isXsmall ? (
        <MobileGrid />
      ) : (
        <Datagrid rowClick="edit">
          <TextField
            source="name"
            label={translate('resources.notifications.fields.name')}
          />
          <ImageField
            source="image"
            label={translate('resources.notifications.fields.image')}
            className="series_image"
          />
          <DateField
            source="date"
            label={translate('resources.notifications.fields.date')}
            showTime
          />
        </Datagrid>
      )}
    </List>
  );
};

export default NotificationsList;
